import React, { useState, useEffect, useRef, useCallback } from "react";
import {
  uploadFile,
  manualCheck,
  fetchFile,
  downloadFile,
  fetchProcessData,
} from "../../../Services/DataServices";
import GenericTable from "./GenericTable";
import AddModal from "../../Forms/AddModal";
import FilteredDataModal from "../../Forms/FilteredDataModal";
import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import Loader from "../../../Components/Common/Loader";
import moment from "moment";
import { FaEye, FaRedo, FaTimes } from "react-icons/fa";
import { FaDownload, FaEdit, FaTrash } from "react-icons/fa";

const CurateDataCont = ({
  isAddModalOpen,
  closeModal,
  setAddModalOpen,
  selectedIndustry,
  setSelectedIndustry,
  file,
  setFile,
  error,
  setError,
  setShowSampleFile,
  showSampleFile,
  totalItems,
  setTotalItems,
  searchQuery,
  setSearchQuery,
  SearchItem,
  setSearchItem,
  refresh,
}) => {
  const [loading, setLoading] = useState(false);
  const [data, setData] = useState([]);
  const [currentPage, setCurrentPage] = useState(1);
  const [totalPages, setTotalPages] = useState(1);
  const [showFilteredData, setShowFilteredData] = useState(false);
  const [filteredData, setFilteredData] = useState([]);
  // const [searchQuery, setSearchQuery] = useState("");
  const [searchBy, setSearchBy] = useState("user");
  // const [searchData , setSearchData] = useState([]);
  const [showModal, setShowModal] = useState(false);
  const [selectedFilePath, setSelectedFilePath] = useState(null);
  const [selectedRow, setSelectedRow] = useState(null);

  const filteredColumnList = [
    { label: "Percentage", field: "checkCutoff" },
    { label: "Accuracy Count", field: "accuracyCount" },
    { label: "Total Count", field: "count" },
    { label: "Accuracy Percentage", field: "percent" },
  ];

  const limit = 50;
  const fetchData = useCallback(async (page, searchQuery = "") => {
    //setLoading(true);
    try {
      // console.log("searchquery",searchQuery);
      const filters = { searchQuery };
      const result = await fetchFile({ page, limit, filters });
      if (result.data) {
        setData(result.data);
        setTotalItems(result?.data.length || 0);
        setTotalPages(result?.pagination?.totalPages || 1);
        setCurrentPage(result?.pagination?.currentPage || 1);
      }
    } catch (error) {
      console.error("Error fetching files:", error);
      setError("Error fetching files.");
      setData([]);
    } finally {
      setTimeout(() => setLoading(false), 100);
    }
  });

    useEffect(() => {
    fetchData();
    toast.success("Data refreshed.!!!");
  }, [refresh]);
  
  useEffect(() => {
    fetchData(currentPage, searchQuery);

    // let interval = setInterval(() => {
    //   fetchData(currentPage, searchQuery);
    // }, 10000);

    // return () => clearInterval(interval);
  }, [searchQuery, currentPage]);


  const handleSubmit = async () => {
    if (!file) {
      toast.error("Please select a CSV file first.");
      return;
    }
    if (!selectedIndustry) {
      toast.error("Please select an industry.");
      return;
    }
    setLoading(true);
    try {
      const user = JSON.parse(localStorage.getItem("user"));
      const data = {
        file,
        userId: user?.userId,
        industry: selectedIndustry,
      };
      const response = await uploadFile(data);
      if (response?.result === false) {
        toast.error(response.message);
      } else if (response.result === true) {
        setAddModalOpen(false);
        setFile(null);
        setSelectedIndustry("");
        setError("");
        toast.success("File uploaded successfully!");
        fetchData(currentPage);
      }
    } catch (err) {
      setError("File upload failed. Please try again.");
      toast.error("File upload failed!");
    } finally {
      setLoading(false);
    }
  };

  const handleReprocess = async (row) => {
    // console.log("row",row);

    setLoading(true);
    try {
      const user = JSON.parse(localStorage.getItem("user"));
      const data = {
        fileId: row._id,
        userId: user?.userId,
        industry: row.industry,
        filename: row.filename,
        filepath: row.filepath,
      };
      const response = await uploadFile(data);
      if (response?.result === false) {
        toast.error(response.message);
      } else if (response.result === true) {
        toast.success("File reprocessing started successfully!");
        fetchData(currentPage);
        checkStatus(response.filename || row.filename);
      }
    } catch (err) {
      toast.error("Reprocessing failed. Please try again.");
      console.error(err);
    } finally {
      setLoading(false);
    }
  };

  const checkStatus = (filename) => {
    const interval = setInterval(async () => {
      const response = await fetchProcessData(filename);
      if (
        response?.fileData?.status === "completed" ||
        response?.fileData?.status === "failed"
      ) {
        fetchData(currentPage);
        clearInterval(interval);
      }
    }, 120000); // 2-minute interval
  };
  const handleDownloadOption = (path) => {
    if (!path.fileUrl) {
      toast.error("No file available for download.");
      return;
    }
    //const path = {fileUrl: row.curatedFilePath, filename: row.curatedFileName};
  
    handleDownload(path);
  };
  

  const handleDownload = async ({fileUrl, filename}) => {
    if (!fileUrl) {
      toast.error("No file available for download.");
      return;
    }
    try {
      await downloadFile({ fileUrl, filename });
      setError("");
    } catch (error) {
      toast.error("Error downloading the file.");
    } finally {
    }
  };


  const handlePageChange = (newPage) => {
    if (newPage > 0 && newPage <= totalPages) {
      setCurrentPage(newPage);
    }
  };

  const handleShowAll = (row) => {
    // console.log(row,"rowwwww")
    // const filtered = row.accuracyArr.map((item) => ({
    //   accuracyCount: item.accuracyCount,
    //   checkCutoff: item.checkCutOff,
    //   count: item.count,
    //   percent: item.percent,
    //   productGroupAccuracy: row?.categorizationAccuracy?.productGroupAccuracy || "N/A",
    //   uniqueProductNameAccuracy: row?.categorizationAccuracy?.uniqueProductNameAccuracy || "N/A",
    //   totalExporter: row?.companyAccuracy?.totalExporter || "N/A",
    //   totalImporter: row?.companyAccuracy?.totalImporter || "N/A",
    //   accuratExporter: row?.companyAccuracy?.accuratExporter || "N/A",
    //   accuratImporter: row?.companyAccuracy?.accuratImporter || "N/A",
    // }));
    const filtered = [
      {
        accuracyCount: row.accuracyCount || "N/A",
        checkCutoff: row.checkCutOff || "N/A",
        count: row.count || "N/A",
        percent: row.percent || "N/A",
        productGroupAccuracy: row?.categorizationAccuracy?.productGroupAccuracy || "N/A",
        uniqueProductNameAccuracy: row?.categorizationAccuracy?.uniqueProductNameAccuracy || "N/A",
        needsToRecheck: row?.categorizationAccuracy?.needsToRecheck || "N/A",
        totalExporter: row?.companyAccuracy?.totalExporter || "N/A",
        totalImporter: row?.companyAccuracy?.totalImporter || "N/A",
        accuratExporter: row?.companyAccuracy?.accuratExporter || "N/A",
        accuratImporter: row?.companyAccuracy?.accuratImporter || "N/A",
      },
    ];

    setFilteredData(filtered);
    setShowFilteredData(true);
  };

  const updatedFilteredData = filteredData.map((row) => ({
    ...row,
    uniqueProductNameAccuracy:
      row?.categorizationAccuracy?.uniqueProductNameAccuracy || 0,
    productGroupAccuracy:
      row?.categorizationAccuracy?.productGroupAccuracy || 0,
  }));

  const columnList = [
    {
      label: "Name",
      field: "filename",
      cell: (row) => (
        <span
          title={row.filename}
          style={{
            cursor: "pointer",
            textDecoration: "underline",
            color: "#4b38b3",
          }}
          onClick={() => handleDownload({fileUrl: row.filepath, filename: row.filename})}
        >
          {row.filename}
        </span>
      ),
    },
    // {
    //   label: "Status",
    //   field: "status",
    //   cell: (row) => (
    //     <span style={{ color: row.status === "processing" ? "orange" : "green" }}>
    //       {row.status === "processing" ? "Processing..." : "Completed"}
    //     </span>
    //   ),
    // },
    {
      label: "Date",
      field: "createdAt",
      cell: (row) => <span>{moment(row.createdAt).format(" DD/MM/YYYY")}</span>,
    },
    {
      label: "Industry",
      field: "industry",
    },
    {
      label: "User",
      field: "",
      cell: (row) => {
        return <div>{row?.user?.firstName}</div>;
      },
    },
    // {
    //   label: "Accuracy Count\n100% | 99%",
    //   width: "2%",
    //   cell: (row) => (row?.accuracy100 ? `${row.accuracy100} | ${row.accuracy99}` : "N/A"),
    // },
    {
      //label: "Company Accuracy\n Importer|Exporter",
      label: "Accuracy(%) | Recheck(%)",
      // width: "2%",
      cell: (row) =>
        row?.categorizationAccuracy
          ? `${row?.categorizationAccuracy?.uniqueProductNameAccuracy || '0.0%'} | ${
              row?.categorizationAccuracy?.needsToRecheck || '0.0%'
            }`
          : "N/A",
    },

    {
      label: "Data Count",
      cell: (row) => <div>{row?.categorizationAccuracy?.totalCount || 0}</div>,
    },
    {
      label: "Proceesing time",
      cell: (row) => <div>{row?.takenTime || "-"}</div>,
    },
    {
      label: "Release",
      cell: (row) => (
        <div>{row.status === "failed" ? "Failed" : "R " + row?.version}</div>
      ),
    },
    // {
    //   label: "Unique Name",
    //   cell: (row) => <div>{row?.categorizationAccuracy?.uniqueProductNameAccuracy || 0}%</div>,
    // },
    // {
    //   label: "Product Group",
    //   cell: (row) => <div>{row?.categorizationAccuracy?.productGroupAccuracy || 0}%</div>,
    // },
    {
      label: "Activity",
      field: "",
      cell: (row) => (
        <div
          style={{
            display: "flex",
            gap: "12px",
            alignItems: "center",
            marginTop: 10,
          }}
        >
          <button
            type="button"
            onClick={() => handleShowAll(row)}
            disabled={row.status === "processing" || row.status === "failed"}
            style={{
              padding: 5,
              backgroundColor: "white",
              color:
                row.status === "processing" || row.status === "failed"
                  ? "#cccccc"
                  : "#4b38b3",
              display: "flex",
              alignItems: "center",
              border: "none",
              cursor:
                row.status === "processing" || row.status === "failed"
                  ? "not-allowed"
                  : "pointer",
            }}
            title="View Accuracy"
          >
            <FaEye style={{ fontSize: 16 }} />
          </button>
          {!row.parentId && (
            <button
              type="button"
              onClick={() => handleReprocess(row)}
              disabled={row.status === "processing"}
              style={{
                padding: 5,
                backgroundColor: "white",
                color: row.status === "processing" ? "#cccccc" : "#4b38b3",
                display: "flex",
                alignItems: "center",
                border: "none",
                cursor: row.status === "processing" ? "not-allowed" : "pointer",
              }}
              title={
                row.status === "processing"
                  ? "Processing in progress"
                  : "Reprocess file"
              }
            >
              <FaRedo style={{ fontSize: 12 }} />
            </button>
          )}
          {/* <button
            type="button"
            onClick={() => handleDownload(row.curatedFilePath || row.filepath)}
            disabled={row.status === "processing" || (!row.curatedFilePath && !row.filepath) || row.status === "failed"}
            style={{
              padding: 5,
              backgroundColor: "white",
              color: row.status === "processing" || row.status === 'failed' ? "red" : "#4b38b3",
              display: "flex",
              alignItems: "center",
              border: "none",
              cursor:
                row.status === "processing" || (!row.curatedFilePath && !row.filepath) || row.status === 'failed'
                  ? "not-allowed"
                  : "pointer",
              opacity:
                row.status === "processing" || (!row.curatedFilePath && !row.filepath) ? 0.5 : 1,
            }}
            title={row.status === "processing" ? "Processing in progress" : "Download file"}
          >
            <FaDownload style={{ fontSize: 16 }} />
          </button> */}
        </div>
      ),
    },
    {
      label: "Downloads",
      field: "",
      cell: (row) => (
        <div>
          {/* <button
            type="button"
            onClick={() => handleDownload(row.curatedFilePath || row.filepath)}
            disabled={row.status === "processing" || (!row.curatedFilePath && !row.filepath) || row.status === "failed"}
            style={{
              padding: 5,
              backgroundColor: "white",
              color: row.status === "processing" || row.status === 'failed' ? "red" : "#4b38b3",
              display: "flex",
              alignItems: "center",
              border: "none",
              cursor:
                row.status === "processing" || (!row.curatedFilePath && !row.filepath) || row.status === 'failed'
                  ? "not-allowed"
                  : "pointer",
              opacity:
                row.status === "processing" || (!row.curatedFilePath && !row.filepath) ? 0.5 : 1,
            }}
            title={row.status === "processing" ? "Processing in progress" : "Download file"}
          >
            <FaDownload style={{ fontSize: 16 }} />
          </button> */}
          <button
            type="button"
            onClick={() => {
              setSelectedRow(row);
              handleDownloadOption({fileUrl: row.curatedFilePath, filename: row.curatedFileName})
              setShowModal(true);
            }}
            disabled={
              row.status === "processing" ||
              (!row.curatedFilePath && !row.filepath) ||
              row.status === "failed"
            }
            style={{
              padding: 5,
              backgroundColor: "white",
              color:
                row.status === "processing" || row.status === "failed"
                  ? "red"
                  : "#4b38b3",
              display: "flex",
              alignItems: "center",
              border: "none",
              cursor:
                row.status === "processing" ||
                (!row.curatedFilePath && !row.filepath) ||
                row.status === "failed"
                  ? "not-allowed"
                  : "pointer",
              opacity:
                row.status === "processing" ||
                (!row.curatedFilePath && !row.filepath)
                  ? 0.5
                  : 1,
            }}
            title={
              row.status === "processing"
                ? "Processing in progress"
                : "Download file"
            }
          >
            <FaDownload style={{ fontSize: 16 }} />
          </button>
        </div>
      ),
    },
  ];

  const renderExpandableRow = (row) => {
    if (!row.reprocessedFiles || row.reprocessedFiles.length === 0) return null;

    return row.reprocessedFiles.map((reprocessedFile) => ({
      ...reprocessedFile,
      filename: `${reprocessedFile.filename}`,
      status: reprocessedFile.status,
      createdAt: reprocessedFile.createdAt,
      industry: reprocessedFile.industry,
      user: reprocessedFile.user,
      accuracy100:
        reprocessedFile.accuracyArr.find((item) => item.checkCutOff === 100)
          ?.percent || "0",
      accuracy99:
        reprocessedFile.accuracyArr.find((item) => item.checkCutOff === 99)
          ?.percent || "0",
      categorizationAccuracy: reprocessedFile.categorizationAccuracy,
    }));
  };
  return (
    <>
      <div>
        {/* {loading && <Loader />} */}
        <AddModal
          isOpen={isAddModalOpen}
          toggleModal={closeModal}
          handleSubmit={handleSubmit}
          file={file}
          setFile={setFile}
          setError={setError}
          modalTitle="Add File"
          btnLabel="Upload File"
          error={error}
          setShowSampleFile={setShowSampleFile}
          showSampleFile={showSampleFile}
          selectedIndustry={selectedIndustry}
          setSelectedIndustry={setSelectedIndustry}
        />

        {/* <div style={{ display: "flex"  }}>
        <form onSubmit={handleSearch} style={{ width: "80%" ,marginBottom: 12}}>
          <select
            value={searchBy}
            onChange={(e) => setSearchBy(e.target.value)}
            style={{ padding: 5, marginRight: 10 }}
          >
            <option value="user">User</option>
            <option value="industry">Industry</option>
            <option value="date">Date</option>
          </select>
          <input
            type="text"
            placeholder="Search by type"
            value={searchQuery}
            onChange={(e) => setSearchQuery(e.target.value)}
            style={{ width: "60%", marginRight: 10 }}
          />
          <button type="submit" style={{ padding: 6, backgroundColor: "#4b38b3", color: "white" }}>
            Search
          </button>
        </form>
      </div> */}

        {loading ? (
          <Loader />
        ) : (
          <GenericTable
            columnList={columnList}
            data={data}
            handleDownload={handleDownload}
            handlePageChange={handlePageChange}
            totalPages={totalPages}
            currentPage={currentPage}
            totalItems={totalItems}
            renderExpandableRow={renderExpandableRow}
          />
        )}
        <FilteredDataModal
          isOpen={showFilteredData}
          toggleModal={() => setShowFilteredData(false)}
          filteredData={filteredData}
          columnList={filteredColumnList}
        />
      </div>
      {/* {showModal && (
        <div
          style={{
            position: "fixed",
            top: 0,
            left: 0,
            width: "100vw",
            height: "100vh",
            backgroundColor: "rgba(0,0,0,0.5)",
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            zIndex: 999,
            opacity: showModal ? 1 : 0,
            transform: showModal ? "scale(1)" : "scale(0.9)",
            transition: "opacity 0.7s ease, transform 0.3s ease",
          }}
        >
          <div
            style={{
              background: "white",
              padding: 20,
              borderRadius: 8,
              width: 350,
              textAlign: "center",
            }}
          >
            <div
              style={{
                display: "flex",
                justifyContent: "space-between",
                alignItems: "baseline",
                fontSize: "20px",
              }}
            >
              <h5>Select Download Option</h5>
              <button
                onClick={() => setShowModal(false)}
                style={{ backgroundColor: "transparent", color: "grey" }}
              >
                <FaTimes />
              </button>
            </div>
            <div
              style={{
                display: "flex",
                flexDirection: "column",
                justifyContent: "center",
                alignItems: "center",
              }}
            >
              <button
                onClick={() => handleDownloadOption("all") }
                style={{
                  margin: 10,
                  backgroundColor: "#4C38B3",
                  padding: "10px",
                  width: "70%",
                }}
              >
                All Records
              </button>
              <button
                onClick={() => handleDownloadOption("doubt")}
                style={{
                  margin: 10,
                  backgroundColor: "#4C38B3",
                  padding: "10px",
                  width: "70%",
                }}
              >
                Records In Doubt
              </button>
              <button
                onClick={() => handleDownloadOption("undefined")}
                style={{
                  margin: 10,
                  backgroundColor: "#4C38B3",
                  padding: "10px",
                  width: "70%",
                }}
              >
                Undefined Records
              </button>
            </div>
          </div>
        </div>
      )} */}
    </>
  );
};

export default CurateDataCont;
